import type { RouteRecordRaw } from 'vue-router';

/**
 * Ambiente público
 */
export const simulationRoutes: Array<RouteRecordRaw> = [
  {
    name: 'PublicSimulationLayout',
    path: '/simulacao',
    props: false,
    meta: { requiresAuth: false },
    component: () => import('@/views/public/PublicLayout.vue'),
    children: [
      {
        name: 'PublicSimulation',
        path: '',
        props: true,
        meta: { requiresAuth: false },
        component: () =>
          import('@/views/public/simulation/PublicSimulation.vue'),
        children: [
          {
            name: 'MultiBankSimulation',
            path: 'imobiliaria/:username',
            component: () =>
              import('@/views/public/simulation/RealtySimulation.vue'),
            meta: { requiresAuth: false },
            props: true,
          },
          {
            name: 'VehicleFinancingSimulation',
            path: 'veicular/:username',
            component: () =>
              import('@/views/public/simulation/VehicleSimulation.vue'),
            meta: { requiresAuth: false },
            props: true,
          },
        ],
      },
    ],
  },
];
